<template>
  <div>
    <a-modal :maskClosable="false" :footer="null" width="50%" v-model:visible="data.visible">
      <template #title>
        <div class="title">
          通话全文
          <div class="tips">已将 AI 与患者的通话记录逐字转写为文字</div>
        </div>
      </template>
      <div class="body">
        <a-spin v-if="data.loading"></a-spin>
        <template v-else>
          <div class="text" v-if="data.textContent">
            {{ data.textContent }}
          </div>
          <a-empty class="empty" :image="emptyImg" v-else></a-empty>
        </template>
      </div>
    </a-modal>
  </div>
</template>

<script setup>
import { getTcccLatest } from '@/api/chat'
import { defineExpose, reactive } from 'vue'
import emptyImg from '@/assets/img/empty.png'

const data = reactive({
  cdrId: '',
  textContent: '',
  loading: false,
  visible: false
})
// 获取通话数据
const getData = () => {
  data.loading = true
  const param = {
    cdrId: data.cdrId
  }
  getTcccLatest(param).then(res => {
    data.textContent = res?.textContent
    data.loading = false
  })
}

const openModal = cdrId => {
  data.visible = true
  data.cdrId = cdrId
  getData()
}
defineExpose({
  openModal
})
</script>

<style lang="scss" scoped>
.title {
  font-weight: 500;
  font-size: 16px;
  color: #000000d9;
  display: inline-block;
  .tips {
    display: inline-block;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    margin-left: 8px;
  }
}
.body {
  height: 690px;
  position: relative;
  .empty {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .text {
    background: #f8f8f8;
    padding: 20px 16px;
    color: #3b3b3b;
    border-radius: 6px;
    max-height: 100%;
    overflow: auto;
    white-space: pre-wrap;
  }
}
</style>
